module.exports = __webpack_public_path__ + "static/media/ic-1.3f2c3181.svg";